import React, { Component } from 'react';
import { Modal, Steps, Button, message } from 'antd';
const Step = Steps.Step;

class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);
    this.steps = {step0: {password: false, password_confirmation: false}};
    this.state = {step: 0, stepLimit: 0, stepValidation: this.steps, profile: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handlePassword = this.handlePassword.bind(this);
    this.handlePasswordConfirmation = this.handlePasswordConfirmation.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.validateStep())
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.profile.password !== this.state.profile.password_confirmation)
      return message.warning('Las contraseñas no coinciden')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.profile.password);
      this.setState({profile: {}, step: 0});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }
      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  handlePassword(event) {
    this.setProp('password', event.target.value);
  }

  handlePasswordConfirmation(event) {
    this.setProp('password_confirmation', event.target.value);
  }

  setProp(prop, value) {
    let profile = this.state.profile;
    let validation = this.state.stepValidation;
    profile[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }

    this.setState({profile: profile, stepValidation: validation});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Confirmar contraseña" />
            <Step title="Finalizar" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Nueva contraseña</label>
              <input type="text" className="form-control" placeholder="******" onChange={this.handlePassword} />
            </div>
            <div className="form-group">
              <label>Confirmar contraseña</label>
              <input type="text" className="form-control" placeholder="******" onChange={this.handlePasswordConfirmation} />
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default ChangePasswordModal;



// WEBPACK FOOTER //
// ./src/components/modals/ChangePasswordModal.js